(function () {
  if (typeof window.__gatedAuth === 'undefined') return;

  var auth = window.__gatedAuth;

  if (auth.loggedIn === false) {
    var here = window.location.pathname + window.location.search;
    document.cookie = 'gated_return_url=' + encodeURIComponent(here) + '; path=/; max-age=600; SameSite=Lax';
    window.location.replace('/account/login?return_url=' + encodeURIComponent(here));
    return;
  }

  if (auth.authorized === false) {
    window.location.replace('/pages/access-denied');
  }
})();
